import { CatalogItemDetailsSection } from './CatalogItemDetailsSection'
import {
  type ConversationDetailSection,
  deriveDetailSectionKey,
} from '../../value-objects/ConversationTurnItem'

export interface ICatalogItemDetailsSectionsProps {
  sections: ConversationDetailSection[]
  onChipSelect: (message: string) => void
}

export const CatalogItemDetailsSections = ({
  sections,
  onChipSelect,
}: ICatalogItemDetailsSectionsProps) => (
  <>
    {sections.map((section) => (
      <CatalogItemDetailsSection
        key={deriveDetailSectionKey(section)}
        section={section}
        onChipSelect={onChipSelect}
      />
    ))}
  </>
)
